import { watchCreateApp } from "./CreateApp";
import { watchCreateCMSToken } from "./CreateCMSToken";
import { watchDeleteApp } from "./DeleteApp";
import { watchDeleteCMSToken } from "./DeleteCMSToken";
import { watchExportApp } from "./ExportApp";
import { watchFetchApp } from "./FetchApp";
import { watchFetchCMSTokens } from "./FetchCMSTokens";
import { watchSearchApps } from "./SearchApps";
import { watchSubmitApp } from "./SubmitApp";
import { watchUpdateApp } from "./UpdateApp";
import { watchUpdateTemplate } from "./UpdateTemplate";
import { watchUploadBanner } from "./UploadBanner";
import { watchUploadIcon } from "./UploadIcon";
import { watchUploadTemplate } from "./UploadTemplate";

export * from "./CreateApp";
export * from "./CreateCMSToken";
export * from "./DeleteApp";
export * from "./DeleteCMSToken";
export * from "./ExportApp";
export * from "./FetchApp";
export * from "./FetchCMSTokens";
export * from "./SearchApps";
export * from "./SubmitApp";
export * from "./UpdateApp";
export * from "./UpdateTemplate";
export * from "./UploadBanner";
export * from "./UploadIcon";
export * from "./UploadTemplate";

export default [
    watchCreateApp,
    watchCreateCMSToken,
    watchDeleteApp,
    watchDeleteCMSToken,
    watchExportApp,
    watchFetchApp,
    watchFetchCMSTokens,
    watchSearchApps,
    watchSubmitApp,
    watchUpdateApp,
    watchUpdateTemplate,
    watchUploadBanner,
    watchUploadIcon,
    watchUploadTemplate
];
